import en from './en.json'
import fa from './fa.json'

export const defaultLocale = 'fa'

export const languages = {
  en: en,
  fa: fa
}



// WEBPACK FOOTER //
// ./src/locale/index.js